<template>
  <a-layout-header class="page-header">
    <div class="page-header-container">
      <div class="logo-content">
        <img src="@/assets/images/logo.jpeg" class="logo" />
        <span class="system-name">天涯广告</span>
      </div>
      <div class="avatar-content">
        <a-space>
          <a-avatar v-if="headImage" :src="headImage">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>
          <a-avatar v-else style="background-color: #1677ff">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>
          <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent>
              {{ userName }}
              <CaretDownOutlined />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;" @click="handleLogout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </a-space>
      </div>
    </div>
  </a-layout-header>
</template>
<script setup>
import router from "@/router";
import { UserOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
let userName = localStorage.getItem('userName')
let headImage = localStorage.getItem('headImage')
const handleLogout = () => {
  localStorage.setItem('token',null);
  localStorage.setItem('userName','');
  localStorage.setItem('headImage','')
  router.push('/login')
}
</script>
<style lang="less" scoped>
// .page-header {
//   .title {
//     color: #fff;
//     font-size: 16px;
//     font-weight: 600;
//   }
// }
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: #001529;
  color: white;
  padding: 0 24px;
  display: flex;
  align-items: center;
  z-index: 100;
}
</style>